import { render, staticRenderFns } from "./DetailsContactInfo.vue?vue&type=template&id=2c7765be"
import script from "./DetailsContactInfo.vue?vue&type=script&lang=js"
export * from "./DetailsContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports